<template>
  <div v-on-clickaway="exit" class="payment-header__price__edit-amount">
    <input v-model="amountToInput" type="number" class="input-edit" />

    <div class="currency">
      {{ invoiceInitialData.currency }}
    </div>
    <!-- 
    <button class="btn-done" @click="disableEditAmount">
      <div class="edit-spinner-container" v-if="updateAmountLoading">
        <spinner-button/>
      </div>

      <checkmark-icon-svg v-else/>
    </button>-->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import { directive as onClickaway } from 'vue-clickaway';

export default {
  data() {
    return {
      amountToInput: null,
    };
  },
  created() {
    this.amountToInput = cloneDeep(this.invoiceInitialData.amount);
  },

  computed: {
    ...mapState(['invoiceInitialData']),
  },

  methods: {
    // ...mapActions(["requestUpdateAmount"]),

    // async disableEditAmount() {
    //   await this.requestUpdateAmount({
    //     id: this.requestId,
    //     data: {
    //       amount: parseInt(this.amountToInput)
    //     }
    //   });

    //   this.exit();
    // },

    exit() {
      this.$emit('edit');
    },
  },

  directives: { onClickaway },
};
</script>

<style lang="scss" scoped>
.payment-header {
  .payment-header__price__edit-amount {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 1.5;
    width: 168.95px;
    margin-top: 5px;

    .input-edit {
      font-size: 16px;
      width: 80px;
      height: 40px;
      background-color: #ffffff;
      box-shadow: inset 0 2px 0 0 rgba(215, 216, 219, 0.25);
      border: solid 1px #b4b5b8;
      padding-left: 5px;
    }

    .currency {
      margin-left: 5px;
      margin-right: 10px;
    }

    .btn-done {
      cursor: pointer;
      width: 24px;
      height: 40px;
      border: 0;
      box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.25);

      .edit-spinner-container {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
      }

      &:disabled {
        background-color: #b4b5b8;
      }

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
